<template>
<div class="chapter">
<div class="inner_page">
<p class="ser"><img alt="0849919533_ePDF_0002_002" id="d12e29" src="images/0849919533_ePDF_0002_002.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Wals_ISBN1418537640_epub_c1_r1.vue?0b295b82